// libs
import { HTMLMotionProps, motion } from "framer-motion";
import { rgba } from "polished";
import styled from "styled-components";
// components
import { Box } from "./Box";
import Icon from "./Icon";
// other
import { IconKey } from "../models/client";
import { Color } from "../models/theme";

type ButtonSize = "sm" | "md" | "lg";

interface IconButtonProps extends HTMLMotionProps<"button"> {
  icon: IconKey;
  size?: ButtonSize;
  color?: Color | "transparent" | "inherit";
}

const buttonSizes = {
  sm: [32],
  md: [40, 48],
  lg: [48],
};

const StyledButton = styled(motion.button)`
  position: relative;
  padding: 0;
  background-color: transparent;
  border-radius: 50%;
  display: block;
  color: inherit;
  /* color: ${({ theme }) => theme.colors.white}; */
  border: none;
  cursor: pointer;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70%;
    height: 70%;
    vertical-align: middle;
  }
`;

const Round = styled(motion.div)`
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  width: 100%;
  border-radius: 50%;
  background-color: ${({ theme }) => rgba(theme.colors.dark, 0.1)};
  z-index: -1;
  opacity: 0;
`;

const IconContainer = styled(Box)`
  position: relative;
`;

const buttonVariants = {
  hover: {
    scale: 1,
  },
  tap: {
    scale: 1,
  },
  initial: {
    scale: 1,
  },
};

const roundVariants = {
  tap: {
    opacity: 1,
  },
  hover: {
    opacity: 0.5,
  },
  initial: {
    opacity: 0,
  },
};

function IconButton({
  icon,
  color = "inherit",
  size = "md",
  ...rest
}: IconButtonProps) {
  return (
    <StyledButton
      animate="initial"
      whileHover="hover"
      whileTap="tap"
      variants={buttonVariants}
      {...rest}
    >
      <Round variants={roundVariants} transition={{ duration: 0.1 }}></Round>
      <IconContainer
        color={color}
        width={buttonSizes[size]}
        height={buttonSizes[size]}
      >
        <Icon icon={icon} />
      </IconContainer>
    </StyledButton>
  );
}

export default IconButton;
